/**
 * 业务系统列定义.
 */

export default {
  code: 200,
  data: {
    items: [
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-edit',
        cssType: '',
        name: '编辑',
        showExp: '{{!!data.urlItemsDef}}',
        param: {
          methodName: 'handleEditRowMenu',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-copy',
        cssType: '',
        name: '复制',
        showExp: '{{!!data.menuCopyAddShow}}',
        param: {
          methodName: 'handleToolbarMenuAdd',
        },
      },
      {
        style: 'error',
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-delete',
        cssType: '',
        name: '删除',
        showExp: '{{!!data.menuDeleteShow}}',
        param: {
          methodName: 'handleDeleteRowMenu',
        },
        enableExp: '',
      },
    ],
  },
  msg: 'string',
  success: false,
}
